/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// The list's filter pills, as in the design.
// The candidate list's work queues (GET /api/v2/anna/candidates?queue=...)
export const QUEUE_PILLS = [
  {key: null, label: 'All', count: 'all'},
  // interviewed, missed the interview, or wrote to the mailbox: HR's turn
  {key: 'attention', label: 'Needs attention', count: 'attention'},
  {key: 'new', label: 'New', count: 'new'},
  {key: 'interviewed', label: 'Interviewed', count: 'interviewed'},
  {key: 'shortlisted', label: 'Shortlisted', count: 'shortlisted'},
  {key: 'rejected', label: 'Rejected', count: 'rejected'},
];

/**
 * green / amber / red for a score out of `max`, by ANNA Settings' score bands
 * (strong match from, worth a look from; the API's `bands`); grey when not scored.
 */
export function scoreTone(value, max = 100, bands = null) {
  if (value === null || value === undefined) return 'grey';
  const pct = (value / max) * 100;
  if (pct >= (bands?.strong ?? 75)) return 'green';
  if (pct >= (bands?.worthALook ?? 50)) return 'amber';
  return 'red';
}

/** YES / NO / UNCLEAR (a core skill the CV only names) / UNKNOWN. */
export function checkTone(value) {
  return {YES: 'green', NO: 'red', UNCLEAR: 'amber'}[value] || 'grey';
}

// a candidate's stage with Anna: its colour, the same on the list and the candidate's page.
// Needing HR: green, amber, red; waiting: blue (booked), grey
const STAGE_TONES = {
  interviewed: 'green',
  replied: 'amber',
  missed: 'red',
  problem: 'amber',
  paused: 'amber',
  answers: 'amber',
};
export function stageTone(stage) {
  if (!stage) return 'grey';
  if (stage.key === 'rejected') return 'red';
  if (stage.attention) return STAGE_TONES[stage.key] || 'amber';
  return stage.key === 'booked' ? 'blue' : 'grey';
}

// where a kept call happened (GoTo and Google Meet: older calls)
export const CALL_SOURCES = {
  goto: 'GoTo meeting',
  jitsi: 'Jitsi meeting',
  meet: 'Google Meet meeting',
  browser: 'Browser test',
};

// a call's recording (audio; `${callId}-video` for the meeting video), as Orbit serves it
export function recordingUrl(candidateId, slot, callId = null) {
  const url = `${window.appGlobal.baseUrl}/anna/recording/${candidateId}/${slot}`;
  return callId ? `${url}?call=${encodeURIComponent(callId)}` : url;
}

// text into the clipboard, and a toast that says so
export function copyText(toast, text, message) {
  return navigator.clipboard
    ?.writeText(text)
    .then(() => toast.success({title: 'Copied', message}));
}
